<template>
  <div>
    <div v-if="canSign" class="mb-2">
      <v-btn class="w-100" @click="signDocument"> Підписати </v-btn>
    </div>
    <div v-if="canCancel" class="mb-2">
      <v-btn class="w-100" color="error" @click="cancelDocument">
        Анулювати
      </v-btn>
    </div>
    <v-divider v-if="canSign || canCancel" class="mb-2"></v-divider>

    <SignatureStatus :document="documentSignature" />
  </div>
</template>

<script lang="ts">
import { useDocumentSignature } from '../index'
import SignatureStatus from '@/components/signature/SignatureStatus.vue'
import { openDialog } from '@/dialog'
import { computed } from 'vue'
import { useCan } from '@/composables/useCan'
import axios from '@/plugins/axios/index.js'
import { urlGetDiiaData, urlSignCreate } from '@/utils/urls'
import {
  DiiaRequestPayload,
  SignedDocument,
} from '@/dialog/components/sign-document/types'

export default {
  name: 'DocumentSign',
  components: { SignatureStatus },
  emits: ['sign'],
  setup(_, { emit }) {
    const { can } = useCan()
    const { userId, documentSignature } = useDocumentSignature()

    // done
    const canSign = computed(() => {
      return (
        [1, 2].includes(documentSignature.statusId) &&
        documentSignature.users?.find(u => u.userId === userId.value)
          ?.isSignature
      )
    })

    // done
    const canCancel = computed(() => {
      return (
        [1, 2].includes(documentSignature.statusId) &&
        documentSignature.authorId === userId.value
      )
    })

    const saveSignatures = async (signatures: SignedDocument[]) => {
      const savedSignatures = []

      for (const signature of signatures) {
        const { data } = await axios.post(urlSignCreate(), {
          documentId: documentSignature.id,
          documentSigned: signature.documentSigned,
          signingDate: signature.signingDate,
          fullCertificate: signature.fullCertificate,
        })

        savedSignatures.push(data)
      }

      return savedSignatures
    }

    const signDocument = () => {
      return openDialog({
        name: 'SignDocument',
        dialogData: {
          documents: documentSignature.document.map(d => {
            return {
              document: d,
              uploadFilesParams: {
                mainFolder: 'document',
                nameFolder: 'signature',
                prefixFolder: String(documentSignature.id),
              },
            }
          }),
          diiaRequest: ({ algo, hash }: DiiaRequestPayload) => {
            return axios.post(urlGetDiiaData(documentSignature.id), {
              algo,
              hash,
            })
          },
        },
        params: {
          hideActionButtons: true,
          cb: async signatures => {
            if (Array.isArray(signatures)) {
              emit('sign', await saveSignatures(signatures))
            } else {
              Object.assign(documentSignature, signatures)
            }
          },
        },
      })
    }

    const cancelDocument = () => {
      can('document-signatures.cancel', () => {
        openDialog({
          name: 'DocumentCancel',
          dialogData: {
            documentId: documentSignature.id,
          },
          params: {
            cb: doc => {
              Object.assign(documentSignature, doc)
            },
          },
        })
      })
    }

    return {
      documentSignature,
      canCancel,
      cancelDocument,
      signDocument,
      canSign,
    }
  },
}
</script>

<style scoped lang="scss"></style>
